var React = require('react');

const TEAM = 'Team Members';
const SUBSCRIBERS = 'Subscribers';
const METRICS = 'Metrics';
const PAGE_ACCESS_GROUPS = 'Page Access Groups';
const TABS = [TEAM, SUBSCRIBERS, METRICS, PAGE_ACCESS_GROUPS];

class ExceedingAllocationsDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: TEAM };
  }

  _toggleTab(tabClicked) {
    this.setState({activeTab: tabClicked});
  }

  _displayTabs() {
    var tabs = [];

    _.map(TABS, (tab) => {
      tabs.push(
        <li key={tab} className={this.state.activeTab === tab ? 'active' : null} onClick={this._toggleTab.bind(this, tab)}>
          <a href="#">{tab}</a>
        </li>
      )
    });

    return <ul className="cpt-tabs"> {tabs} </ul>;
  }

  _determineData() {
    if (this.state.activeTab === TEAM) { return this.props.team_results }
    else if (this.state.activeTab === SUBSCRIBERS) { return this.props.subscriber_results }
    else if (this.state.activeTab === METRICS) { return this.props.metric_results }
    else if (this.state.activeTab === PAGE_ACCESS_GROUPS) { return this.props.page_access_group_results }
  }

  _displayData() {
    var data = this._determineData();
    var rows = [];

    if (data.length > 0) {
      rows.push(
        <div className="table-row column-header">
          <div className="row">
            <div className="span6">{this.state.activeTab === TEAM ? "Organization " : "Team "}Name</div>
            <div className="span3">Over By</div>
          </div>
        </div>
      );

      _.map(data, function (datapoint) {
        rows.push(
          <div className="table-row">
            <div className="row">
              <div className="span6"><a href={datapoint.snapshot_link}>{datapoint.name}</a></div>
              <div className="span3">{datapoint.over_allocation_count}</div>
            </div>
          </div>
        )
      });
    } else {
      rows.push(
        <span key={this.state.activeTab}>
          <em>Good news! No one is over their allocations for {this.state.activeTab}.</em>
        </span>
      )
    }

    return rows;
  }

  csvRoute() {
    return Routes.admin_exceeding_allocations_path({format: 'csv'});
  }

  render() {
    return (
      <div className="content-area">
        <div className="header">
          <a href={this.csvRoute()} className="cpt-button size-small style-primary pull-right"> Download as CSV </a>
          <h3 className="page-header">Exceeding allocations dashboard</h3>
        </div>

        { this._displayTabs() }

        <div className="cpt-table">
          <div className="content">
            <div className="table-row-group">

              { this._displayData() }

            </div>
          </div>
        </div>
      </div>
    )
  }
}

module.exports = ExceedingAllocationsDashboard;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/admin/exceeding_allocations/exceeding_allocations_dashboard.jsx